import React, { useEffect } from 'react'
import { useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { translate } from '../../../../utils/language';
import { Calendar } from 'primereact/calendar';
import '../extraTable.css';
import { TreeSelect } from 'primereact/treeselect';
const FilterTypes = {
  "multi": ({ selectedOption, onSelectChange, options, placeholder, setData }) => {
    return (<MultiSelect
      value={selectedOption}
      onChange={(e) => {
        onSelectChange(e.value, setData);
      }}
      options={options}
      optionLabel="name"
      virtualScrollerOptions={{ itemSize: 43 }}
      maxSelectedLabels={2}
      placeholder={placeholder}
      filterPlaceholder={placeholder}
      filter={true}
      showClear={true}
      className='w-full max-w-full'
    />)
  },
  "toggle": ({ selectedOption, onSelectChange, options, placeholder, setData }) => {

    const valueObject = {};
    for (const item of (selectedOption || [])) {
      valueObject[item.id] = item;
    }
    return (<TreeSelect
      value={valueObject}
      onChange={(e) => {
        if (e.value) {
          const values = Object.keys(e.value).map((key) => {
            const value = e.value?.[key]
            return {
              id: key,
              checked: value.checked,
              partialChecked: value.partialChecked
            }
          })
          return onSelectChange(values, setData);
        }
        onSelectChange([], setData)
      }}
      togglerTemplate={togglerTemplate}
      options={options}
      virtualScrollerOptions={{ itemSize: 43 }}
      maxSelectedLabels={2}
      placeholder={placeholder}
      filterPlaceholder={placeholder}
      filter={true}
      selectionMode="checkbox"
      showClear={true}
      metaKeySelection={false}
      className='w-full max-w-full'
    />)
  },
  "single": ({ selectedOption, onSelectChange, options, setData, placeholder }) => {

    return (
      <Dropdown
        placeholder={placeholder}
        value={selectedOption}
        onChange={(e) => { onSelectChange(e.value, setData) }}
        options={options}
        optionLabel="name"
        className='w-full max-w-full'
      />
    )
  },
  "datetime": ({ selectedOption, onSelectChange, setData, placeholder }) => {
    const value = selectedOption?.id?.map((date) => date)

    return <Calendar
      value={value}
      onChange={(e) => {
        const newDatetime = e.target.value
        const newData = { ...selectedOption }
        newData.id = newDatetime
        onSelectChange(newData, setData)
      }
      }
      selectionMode="range"
      readOnlyInput
      placeholder={placeholder}

    />
  }
}

const togglerTemplate = (node, options) => {
  const level = options?.props
  return (
    <div {...options.props} node={""} className='px-2' onClick={options.onClick}>
      {options.element}
    </div>
  );
};


function FilterSelect({ type, selectedOption, onSelectChange, placeholder, options, error, setData }) {
  const RenderComponent = FilterTypes[type] || FilterTypes["single"]

  if (!RenderComponent) return <></>
  return (
    <div className="col-span-4 lg:col-span-2 items-center max-h-[45px]">
      <div className="px-[8px] h-[45px] w-[180px] ">
        <RenderComponent options={options} selectedOption={selectedOption}  {...{ onSelectChange, placeholder, setData }} ></RenderComponent>

      </div>
    </div>

  )
}

export default FilterSelect